//Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - Start
import { DASHBOARD } from "../actionTypes";

const initialState = {
    arrInvestments: null
};

const investmentsReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case DASHBOARD.GET_INVESTMENTS:
            return {
                ...state,
                arrInvestments: actions.payload
            }
        default:
            return state;
    }
};
export default investmentsReducer;
//Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - End